import React from 'react';
import { IconProps } from '../types';
const MinecraftLight13: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="0" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="4" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="5" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="6" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="7" y="0" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="0" y="1" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="1" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="1" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="1" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="1" y="3" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="0" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(248, 248, 246, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(247, 246, 244, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(247, 247, 246, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(247, 246, 244, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(247, 246, 244, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(236, 235, 214, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(236, 235, 214, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(248, 201, 83, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(247, 246, 244, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(191, 189, 189, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(191, 189, 189, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(253, 230, 152, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(245, 209, 115, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(129, 120, 124, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(245, 209, 115, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(238, 173, 65, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(191, 189, 189, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(191, 189, 189, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(129, 120, 124, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(129, 120, 124, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(191, 189, 189, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(129, 120, 124, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(129, 120, 124, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
</svg>);
export default MinecraftLight13;